const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    defaultPath: '/',
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 4,
    //serverURL: 'https://localhost:7028'
    serverURL: 'https://swastikhmsbetest.agsapplications.com'
};

export default config;
